import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { applyTheme, getTheme } from "@/hooks/useTheme";
import { Layout } from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Schedule from "@/pages/Schedule";
import Scores from "@/pages/Scores";
import Standings from "@/pages/Standings";
import PlayerStats from "@/pages/PlayerStats";
import PlayerProfile from "@/pages/PlayerProfile";
import WeeklyLeaders from "@/pages/WeeklyLeaders";
import Postseason from "@/pages/Postseason";
import Compare from "@/pages/Compare";
import TeamDetail from "@/pages/TeamDetail";

function App() {
  useEffect(() => {
    applyTheme(getTheme());
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/scores" element={<Scores />} />
          <Route path="/standings" element={<Standings />} />
          <Route path="/stats" element={<PlayerStats />} />
          <Route path="/player/:id" element={<PlayerProfile />} />
          <Route path="/weekly" element={<WeeklyLeaders />} />
          <Route path="/postseason" element={<Postseason />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/team/:id" element={<TeamDetail />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
